module.exports = __webpack_public_path__ + "fonts/StagSans-Thin-Italic.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Thin-Italic.otf
// module id = 1083
// module chunks = 0